import covademBetaLogo from '../assets/svgs/covadem-beta-logo.svg';
import covademLogo from '../assets/svgs/covadem-logo.svg';

import blueCross from '../assets/svgs/blue-cross.svg';
import blueMoreDots from '../assets/svgs/blue-more-dots.svg';
import blueSettings from '../assets/svgs/blue-settings.svg';

import whitePegel from '../assets/svgs/white-pegel.svg';
import whiteBridge from '../assets/svgs/white-bridge.svg';
import blueList from '../assets/svgs/blue-list.svg';
import blueMapPin from '../assets/svgs/blue-map-pin.svg';
import blueMap from '../assets/svgs/blue-map.svg';
import mapboxLogo from '../assets/svgs/mapbox-logo-white.svg';

import whiteSmallArrowUp from '../assets/svgs/white-small-arrow-up.svg';
import whiteSmallArrowDown from '../assets/svgs/white-small-arrow-down.svg';
import whiteSmallEqual from '../assets/svgs/white-small-equal.svg';
import yellowWarningTriangle from '../assets/svgs/yellow-warning-triangle.svg';

import whiteSmallDown from '../assets/svgs/white-small-down.svg';
import blueSwapArrows from '../assets/svgs/blue-swap-arrows.svg';

import whiteCross from '../assets/svgs/white-cross.svg';
import whiteMapPin from '../assets/svgs/white-map-pin.svg';
import greyImgFallbackCircle from '../assets/svgs/grey-img-fallback-circle.svg';
import blueOuterLinkArrow from '../assets/svgs/blue-outer-link-arrow.svg';
import whiteRaai from '../assets/svgs/white-raai.svg';
import whiteWaterDepth from '../assets/svgs/white-water-depth.svg';
import whiteWaterLevel from '../assets/svgs/white-water-level.svg';
import whiteBridgeClearance from '../assets/svgs/white-bridge-clearance.svg';
import whiteCreativeCommons from '../assets/svgs/white-creative-commons.svg';

import whiteMediumArrowLeft from '../assets/svgs/white-medium-arrow-left.svg';
import blueSmallArrowLeft from '../assets/svgs/blue-small-arrow-left.svg';
import blueSmallArrowRight from '../assets/svgs/blue-small-arrow-right.svg';

import blackWaterDepth from '../assets/svgs/black-water-depth.svg';
import blueRouteSectionFocus from '../assets/svgs/blue-route-section-focus.svg';
import blueBigBridgePin from '../assets/svgs/blue-big-bridge-pin.svg';
import blueBigPegelPin from '../assets/svgs/blue-big-pegel-pin.svg';
import blueBigSpinnerAnimated from '../assets/svgs/blue-big-spinner-animated.svg';
import blueSignOut from '../assets/svgs/blue-sign-out.svg';

import whiteCrossCircle from '../assets/svgs/white-cross-circle.svg';
import whiteWarningCircle from '../assets/svgs/white-warning-circle.svg';
import whiteCheckCircle from '../assets/svgs/white-check-circle.svg';
import whiteInfoCircle from '../assets/svgs/white-info-circle.svg';

import blueFleetShips from '../assets/svgs/blue-fleet-ships.svg';
import blueShip from '../assets/svgs/blue-ship.svg';
import bluePerformance from '../assets/svgs/blue-performance.svg';
import blueRoute from '../assets/svgs/blue-route.svg';

import tiltedDashes from '../assets/svgs/tilted-dashes.svg';
import blackChart from '../assets/svgs/black-chart.svg';
import whiteMargin from '../assets/svgs/white-margin.svg';
import blackCalculator from '../assets/svgs/black-calculator.svg';

import whitePercentage from '../assets/svgs/white-percentage.svg';
import whiteSquat from '../assets/svgs/white-squat.svg';
import whiteWaterDepthAlternative from '../assets/svgs/white-water-depth-alternative.svg';
import whiteCalculator from '../assets/svgs/white-calculator.svg';

// TODO: revisit icons
const ImageAssets = {
  mobileControls: {
    close: blueCross,
    more: blueMoreDots,
    settings: blueSettings,
  },
  tripControls: {
    pointButtonIcon: whitePegel,
    bridgeButtonIcon: whiteBridge,
    tableButtonIcon: blueList,
    mapButtonIcon: blueMap,
    calculator: whiteCalculator,
    lowestValueIndicators: whiteWaterDepth,
  },
  tableDesktop: {
    pointIcon: blueMapPin,
    bridgeIcon: blueMapPin,
    arrowUp: whiteSmallArrowUp,
    arrowDown: whiteSmallArrowDown,
    equal: whiteSmallEqual,
    warning: yellowWarningTriangle,
  },
  tableMobile: {
    point: whitePegel,
    bridge: whiteBridge,
  },
  routeSelector: {
    pointIcon: whitePegel,
    bridgeIcon: whiteBridge,
    arrow: whiteSmallDown,
    swap: blueSwapArrows,
    margin: whiteMargin,
    calculator: blackCalculator,
    marginPercentage: whitePercentage,
    squatTrim: whiteSquat,
    waterDepth: whiteWaterDepthAlternative,
  },
  modal: {
    closeIcon: whiteCross,
    whitePin: whiteMapPin,
    fallbackImg: greyImgFallbackCircle,
    moreInfo: blueOuterLinkArrow,
    raai: whiteRaai,
    waterDepth: whiteWaterDepth,
    waterLevel: whiteWaterLevel,
    bridgeClearance: whiteBridgeClearance,
    creativeCommons: whiteCreativeCommons,
  },
  dayPicker: {
    arrow: whiteMediumArrowLeft,
    arrowLeftBlue: blueSmallArrowLeft,
    arrowRightBlue: blueSmallArrowRight,
  },
  map: {
    bridgeOffWhite: whiteBridge,
    pointOffWhite: whitePegel,
    lowestWaterDepth: blackWaterDepth,
    mapOptions: {
      closeIcon: whiteCross,
      more: blueMoreDots,
    },
    mapboxLogo,
    mapCenterControls: {
      icon: blueRouteSectionFocus,
    },
    bridgePin: blueBigBridgePin,
    pegelPin: blueBigPegelPin,
  },
  spinner: blueBigSpinnerAnimated,
  signOut: blueSignOut,
  mainLogo: covademLogo,
  mainLogoBeta: covademBetaLogo,
  notifications: {
    info: whiteInfoCircle,
    success: whiteCheckCircle,
    warning: whiteWarningCircle,
    error: whiteCrossCircle,
    close: whiteCross,
  },
  navigation: {
    routes: blueRoute,
    performance: bluePerformance,
    ship: blueShip,
    more: blueMoreDots,
    fleet: blueFleetShips,
  },
  lowestValueIndicators: {
    arrowUp: whiteSmallArrowUp,
    arrowDown: whiteSmallArrowDown,
    equal: whiteSmallEqual,
  },
  graph: {
    dashes: tiltedDashes,
  },
  chart: blackChart,
};

export default ImageAssets;
